import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icon_close.png'


const _hoisted_1 = { class: "pantry-camera-check-main-view" }
const _hoisted_2 = { class: "pantry-camera-check-main-view-area" }
const _hoisted_3 = { class: "pantry-camera-check-main-view-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-camera-check-main-view-close-image",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryCameraCheckSelectView = _resolveComponent("PantryCameraCheckSelectView")
  const _component_PantryCameraCheckBottomView = _resolveComponent("PantryCameraCheckBottomView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_PantryCameraCheckSelectView, {
        class: "pantry-camera-check-main-view-select-view",
        update: _ctx.update,
        selectPosition: _ctx.selectPosition,
        foodList: _ctx.foodList,
        isFoodTimerExec: _ctx.isFoodTimerExec,
        onClickFood: _ctx.onClickFood,
        onClickInput: _ctx.onClickInput,
        onSelectImage: _ctx.selectImage,
        onStatus: _ctx.onStatus
      }, null, 8, ["update", "selectPosition", "foodList", "isFoodTimerExec", "onClickFood", "onClickInput", "onSelectImage", "onStatus"]),
      _withDirectives(_createVNode(_component_PantryCameraCheckBottomView, {
        class: "pantry-camera-check-main-view-bottom-view",
        selectPosition: _ctx.selectPosition,
        foodList: _ctx.foodList,
        onClickBack: _ctx.onClickBack,
        onClickSkip: _ctx.onClickSkip
      }, null, 8, ["selectPosition", "foodList", "onClickBack", "onClickSkip"]), [
        [_vShow, !_ctx.singleMode]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "pantry-camera-check-main-view-close-view",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickClose(...args)))
      }, [
        _hoisted_4
      ])
    ])
  ]))
}